import { useState } from 'react';

export type VisualType = 'stacked' | 'treemap';

export function useVisualType(): [VisualType, (type: VisualType) => void] {
  const [chartType, setChartType] = useState<VisualType>('treemap');
  return [chartType, setChartType];
}
